const TIER_CLASSES = {
  'free': 'feature-gate-modal__chip--free',
  'starter': 'feature-gate-modal__chip--starter',
  'pro': 'feature-gate-modal__chip--pro',
  'enterprise': 'feature-gate-modal__chip--enterprise',
  'lite': 'feature-gate-modal__chip--lite',
  'business': 'feature-gate-modal__chip--business'
}

// Populates and shows the shared #featureGateModal.
// `opts` keys: tierLabel, title, description, tier, upgradeUrl, price
export function populateAndShowModal (opts) {
  const modal = document.getElementById('featureGateModal')
  if (!modal) return

  const currentTier = (document.body.dataset.currentTier || 'free').toLowerCase()
  const currentTierLabel = currentTier.charAt(0).toUpperCase() + currentTier.slice(1)

  const badge = modal.querySelector('[data-fg-tier-badge]')
  if (badge) badge.innerHTML = '<i class="fas fa-lock"></i> ' + opts.tierLabel + ' feature'

  const titleEl = modal.querySelector('[data-fg-title]')
  if (titleEl) titleEl.textContent = opts.title

  const descEl = modal.querySelector('[data-fg-description]')
  if (descEl) descEl.textContent = opts.description

  const currentChip = modal.querySelector('[data-fg-current-tier]')
  if (currentChip) {
    currentChip.textContent = currentTierLabel
    currentChip.className = 'feature-gate-modal__chip ' + (TIER_CLASSES[currentTier] || TIER_CLASSES['free'])
  }

  const requiredChip = modal.querySelector('[data-fg-required-tier]')
  if (requiredChip) {
    requiredChip.textContent = opts.tierLabel
    requiredChip.className = 'feature-gate-modal__chip ' + (TIER_CLASSES[opts.tier] || TIER_CLASSES['starter'])
  }

  const cta = modal.querySelector('[data-fg-cta]')
  if (cta) {
    cta.href = opts.upgradeUrl
    cta.innerHTML = '<i class="fas fa-arrow-up"></i> Upgrade to ' + opts.tierLabel
  }

  const priceEl = modal.querySelector('[data-fg-price]')
  if (priceEl) {
    const priceText = opts.price || ''
    priceEl.textContent = priceText
    priceEl.style.display = priceText ? 'block' : 'none'
  }

  const bsModal = bootstrap.Modal.getOrCreateInstance(modal)
  bsModal.show()
}
